import { fromJsonArray } from 'src/core/utils';
import ActionDTO from '../basic-types/ActionDTO';
import { MyOffer } from './MyOffer';

export type OfferState = 'new' | 'offered' | 'ordered' | 'expired';

export type OfferAction = 'DIALOG_VIEW' | 'ACTION_EDIT';

interface OfferPerson {
    id?: number;
    name: string;
    type: 'Customer' | 'Partner' | 'Unlinked';
}

export class Offer extends MyOffer {
    public readonly state: OfferState;
    public readonly possibleActions: ActionDTO<OfferAction>[];
    public readonly person: OfferPerson;

    constructor(json: any) {
        super(json);

        this.state = json.state;
        this.possibleActions = fromJsonArray<ActionDTO<OfferAction>>(ActionDTO, json.possibleActions);
        this.person = {
            id: json.idTarget,
            name: json.idTarget ? `${json.firstName} ${json.lastName}` : this.billingAddress.addresseeName,
            type: json.userType ?? 'Unlinked',
        };
    }
}
